import { ModalRef, WorkstreamCardData } from 'constants/WorkingModePathwaysConstants'

import { PathwayAgendaDetailButtons } from './PathwayAgendaDetailButtons'
import { renderSegments } from './renderSegments'

interface WorkstreamCardProps {
  card: WorkstreamCardData
  onOpenModal: (ref: ModalRef) => void
}

export const WorkstreamCard = ({ card, onOpenModal }: WorkstreamCardProps) => (
  <div className="pathway-workstream-card">
    <div className="flex flex-col gap-2 items-start w-full">
      <p className="title-xxs w-full">{card.title}</p>
      <p className="body-s w-full">{renderSegments(card.segments)}</p>
    </div>
    <PathwayAgendaDetailButtons actions={card.actions} onOpen={onOpenModal} />
  </div>
)
